var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item align-self-center cursor-pointer"},[_c('div',{on:{"click":_vm.toggleMode}},[_c('i',{staticClass:"mdi mdi_icon mdi-24px mdi-theme-light-dark mr-1"}),_vm._v("\n    "+_vm._s(_vm.btnText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }